/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ResponseClinicDto } from '../../models/response-clinic-dto';
import { UpdateClinicDto } from '../../models/update-clinic-dto';

export interface ClinicsControllerUpdate$Params {

/**
 * The tenant of the clinic
 */
  tenant: string;

/**
 * The id of the clinic
 */
  id: string;
      body: UpdateClinicDto
}

export function clinicsControllerUpdate(http: HttpClient, rootUrl: string, params: ClinicsControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<ResponseClinicDto>> {
  const rb = new RequestBuilder(rootUrl, clinicsControllerUpdate.PATH, 'put');
  if (params) {
    rb.path('tenant', params.tenant, {});
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ResponseClinicDto>;
    })
  );
}

clinicsControllerUpdate.PATH = '/thalea-clinics/clinics/{tenant}/{id}';
